<template>
  <StageScaler>
    <TechCheckBrandingPreview data-testid="techcheck-branding" :disabled="!theme_obj?.enable_tech_check" />
  </StageScaler>
</template>

<script>
import { TechCheckBrandingPreview } from '@goldcast/uicomponents-branding';
import { mapGetters } from 'vuex';

import StageScaler from './StageScaler.vue';

export default {
  name: 'TechCheckBrandingStagePreview',
  components: { TechCheckBrandingPreview, StageScaler },
  computed: {
    ...mapGetters('branding', ['theme_obj'])
  }
};
</script>
